
import { mapGetters, mapState } from "vuex";
// mixins
import OpendataModuleMixin from "@/mixins/opendata-module.mixin";
import ButtonTextOn from "@/mixins/button-text-on";
import TypesMixin from "vue-typed-mixins";
import SplitViewMixin from "@/mixins/split-view";
import MapFilterButtonMixin from "@/mixins/map-filter-buttons";
import PlaceCategoryMixin2 from "@/mixins/filter-genre.mixin";
import Vue2Filters from "vue2-filters";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import { hasAccessToken } from "@/mixins/common-functions";
// compnents
import VButton from "@/components/common/button.vue";
import FilterList from "@/components/filters/filter-list.vue";
import FilterButton from "@/components/filters/filter-button.vue";
import MapViewSearchBtn from "./map-view-search-btn.vue";

export default TypesMixin(
  MapFilterButtonMixin,
  SplitViewMixin,
  PlaceCategoryMixin2,
  ButtonTextOn,
  OpendataModuleMixin,
).extend({
  name: "component-map-header",
  mixins: [
    Vue2Filters.mixin,
    MapFilterButtonMixin,
    SplitViewMixin,
    PlaceCategoryMixin2,
    ButtonTextOn,
    OpendataModuleMixin,
  ],
  components: { VButton, FilterList, FilterButton, MapViewSearchBtn },
  props: {
    isSearchAgain: Boolean,
    hide: Boolean,
    // pTextOn is in Mixin button-text-on
    // pTextOn: Boolean,
  },
  watch: {
    $selectedGenre(genre: string | undefined) {
      this.setFilterButtonSelected("genre", genre ? true : false);
      this.setupGenreFilterButton(this.filterButtons, genre);
    },
    $selectedTopPlace(topPlace: PortalAdapterApi.TopArea) {
      this.checkAreaButton(topPlace);
    },
    // update filterButtons for virtualDOM to update UI
    selectedFilterRadioButtons(buttons: string[]) {
      const hasVacant = buttons.includes("vacant");
      this.setFilterButtonSelected("vacant", hasVacant);
      const hasFavorite = buttons.includes("favorite");
      this.setFilterButtonSelected("favorite", hasFavorite);
    },
  },
  computed: {
    ...mapState("ui", ["vacancyErrorBannerShown"]),
    // getters
    ...mapGetters("ui", ["isMap"]),
    ...mapGetters("data", ["isPlaceListNoData"]),
    isPollSearchBtn(): boolean {
      return this.selectedGenre === "polling-place";
    },
    showHinanjoLink(): boolean {
      return this.selectedGenre === "disaster-prevention";
    },
    currentEnv(): string {
      return process.env.VUE_APP_MODE || "development";
    },
  },
  created() {
    this.$once("hook:mounted", () => {
      this.setupGenreAreaButtons();
    });
  },
  methods: {
    setupGenreAreaButtons() {
      setTimeout(() => {
        if (this.selectedGenre) {
          this.setupGenreFilterButton(this.filterButtons, this.selectedGenre);
        }
        this.checkAreaButton(this.$selectedTopPlace);
      }, 500);
    },
    checkAreaButton(_topPlace: PortalAdapterApi.TopArea) {
      this.selectAreaFilterButtonMixin(_topPlace);
      this.assignAreaButton(_topPlace);
    },
    assignAreaButton(place: PortalAdapterApi.TopArea) {
      const targetBtn = this.filterButtons.find((button) => button.name === "area");
      if (targetBtn === undefined) return;
      targetBtn.title = place.displayText;
    },
    filterBtnClicked(whichBtn: string) {
      if (whichBtn === "menu") {
        return this.openMenu();
      }
      if (whichBtn === "favorite" && !hasAccessToken()) {
        return this.$store.commit("ui/setFavoritePrompt", true);
      }
      this.$emit("filter-clicked", whichBtn);
    },
    searchBtnClicked() {
      this.$emit("search-again-clicked");
    },
    pollSearchBtnClicked() {
      console.log(`pollSearchBtnClicked in map header2`);
      this.$emit("poll-search-clicked");
    },
  },
});
